import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';

import styles from './email-row-item.module.css';

export class EmailRowItemLoading extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles['email-row-item--expanded']}>
                <div className='flex justify-center align-center'>
                    <LoadingIcon size={24} fill={colors.offWhiteDk} />
                </div>
            </div>
        );
    }
}
